export * from '../prestador-servico/list/prestadorServicoList.component';
export * from '../prestador-servico/create/prestadorServicoCreate.component';
export * from '../prestador-servico/edit/prestadorServicoEdit.component';
export * from '../prestador-servico/detail/prestadorServicoDetail.component';
export * from '../prestador-servico/search/prestadorServicoSearch.component';